if (!customElements.get('info-pill-tooltip')) {
  customElements.define(
    'info-pill-tooltip',
    class InfoPillTooltip extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('[data-info-pill-tooltip-trigger]');
        this.panel = this.querySelector('[data-info-pill-tooltip]');
        if (!this.trigger || !this.panel) return;

        this.closeButton = this.panel.querySelector('[data-info-pill-tooltip-close]');

        this.trigger.addEventListener('click', this.open.bind(this));
        this.closeButton?.addEventListener('click', this.close.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      get isOpen() {
        return this.panel.classList.contains('active');
      }

      open() {
        if (this.isOpen) return;

        this.panel.classList.add('active');
        this.trigger.setAttribute('aria-expanded', 'true');

        trapFocus(this.panel, this.closeButton);
      }

      close() {
        if (!this.isOpen) return;

        this.panel.classList.remove('active');
        this.trigger.setAttribute('aria-expanded', 'false');

        removeTrapFocus(this.trigger);
      }

      onKeyDown(event) {
        if (event.key === 'Escape') this.close();
      }
    }
  );
}
